var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m13.245 10.333-3.68-6.39a1.48 1.48 0 0 0-2.566 0l-3.681 6.39c-.57.99.142 2.227 1.283 2.227h7.361c1.14 0 1.853-1.237 1.283-2.227M7.89 4.459a.45.45 0 0 1 .78 0l3.682 6.39a.452.452 0 0 1-.39.678H4.6a.452.452 0 0 1-.39-.678zm.929 2.227a.516.516 0 1 0-1.03 0V8.3a.516.516 0 1 0 1.03 0zm-.516 4.066a.677.677 0 1 0-.001-1.354.677.677 0 0 0 .001 1.354",
    clipRule: "evenodd"
  })));
};
export default SvgWarning;